var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
Opal.modules["diceBot/SwordWorld"] = function(Opal) {
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars, $hash2 = Opal.hash2;

  Opal.add_stubs(['$setPrefixes', '$=~', '$debug', '$gsub', '$>=', '$<=', '$!=', '$==', '$rating', '$getRatingCommandStrings', '$getRateUpFromString', '$getCriticalFromString', '$getDiceChangesFromString', '$getKeyAndAddValueFromString', '$to_i', '$getSW2_0_RatingTable', '$-', '$length', '$>', '$getNewRates', '$<', '$+', '$getAdditionalString', '$loop', '$rollDice', '$getAdditionalDiceValue', '$min', '$*', '$[]', '$<<', '$getResultText', '$parren_killer', '$each', '$split', '$push', '$[]=', '$roll', '$to_s', '$sendMode', '$join', '$getAddText', '$===']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'SwordWorld');

    var $nesting = [self].concat($parent_nesting), $SwordWorld_initialize$1, $SwordWorld_gameName$2, $SwordWorld_gameType$3, $SwordWorld_getHelpMessage$4, $SwordWorld_getHelpMessage$5, $SwordWorld_changeText$6, $SwordWorld_getRatingCommandStrings$11, $SwordWorld_check_2D6$12, $SwordWorld_rollDiceCommand$13, $SwordWorld_rating$14, $SwordWorld_getAdditionalString$16, $SwordWorld_getAdditionalDiceValue$17, $SwordWorld_getCriticalFromString$18, $SwordWorld_getDiceChangesFromString$19, $SwordWorld_getRateUpFromString$20, $SwordWorld_getKeyAndAddValueFromString$21, $SwordWorld_getSW2_0_RatingTable$22, $SwordWorld_getNewRates$23, $SwordWorld_rollDice$25, $SwordWorld_getResultText$26, $SwordWorld_getAddText$27, $SwordWorld_setRatingTable$28;

    self.$$prototype.rating_table = nil;
    
    self.$setPrefixes(["K\\d+.*"]);
    
    Opal.def(self, '$initialize', $SwordWorld_initialize$1 = function $$initialize() {
      var $iter = $SwordWorld_initialize$1.$$p, $yield = $iter || nil, self = this, rating_table = nil;

      if ($iter) $SwordWorld_initialize$1.$$p = null;
      
      rating_table = 0;
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $SwordWorld_initialize$1, false), [], null);
      return (self.rating_table = rating_table);
    }, $SwordWorld_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $SwordWorld_gameName$2 = function $$gameName() {
      var self = this;

      return "ソードワールド"
    }, $SwordWorld_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $SwordWorld_gameType$3 = function $$gameType() {
      var self = this;

      return "SwordWorld"
    }, $SwordWorld_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $SwordWorld_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "自動的成功、成功、失敗、自動的失敗の自動判定を行います。\n" + "\n" + "・レーティング表　(Kx)\n" + "　\"Kキーナンバー+ボーナス\"の形で記入します。\n" + "　ボーナスの部分に「K20+K30」のようにレーティングを取ることは出来ません。\n" + "　また、ボーナスは複数取ることが出来ます。\n" + "　レーティング表もダイスロールと同様に、他のプレイヤーに隠れてロールすることも可能です。\n" + "　例）K20　　　K10+5　　　k30　　　k10+10　　　Sk10-1　　　k10+5+2\n" + "\n" + "・クリティカル値の設定\n" + "　クリティカル値は\"[クリティカル値]\"で指定します。\n" + "　指定しない場合はクリティカル値10とします。\n" + "　クリティカル処理が必要ないときは13などとしてください。(防御時などの対応)\n" + "　またタイプの軽減化のために末尾に「@クリティカル値」でも処理するようにしました。\n" + "　例）K20[10]　　　K10+5[9]　　　k30[10]　　　k10[9]+10　　　k10-5@9\n"
    }, $SwordWorld_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $SwordWorld_getHelpMessage$5 = function $$getHelpMessage() {
      var self = this;

      return "・SW　レーティング表　　　　　(Kx[c]+m$f) (x:キー, c:クリティカル値, m:ボーナス, f:出目修正)"
    }, $SwordWorld_getHelpMessage$5.$$arity = 0);
    
    Opal.def(self, '$changeText', $SwordWorld_changeText$6 = function $$changeText(string) {
      var $a, $$7, $$8, $$9, $$10, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      if ($truthy(/(^|\s)[sS]?(K[\d]+)/i['$=~'](string))) {
      } else {
        return string
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.$debug("parren_killer_add before string", string);
      string = $send(string, 'gsub', [/\[(\d+)\]/i], ($$7 = function(){var self = $$7.$$s || this, $b;

      
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        return "" + "c[" + (__last__match__1) + "]";}, $$7.$$s = self, $$7.$$arity = 0, $$7));
      string = $send(string, 'gsub', [/\@(\d+)/i], ($$8 = function(){var self = $$8.$$s || this, $b;

      
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        return "" + "c[" + (__last__match__1) + "]";}, $$8.$$s = self, $$8.$$arity = 0, $$8));
      string = $send(string, 'gsub', [/\$([\+\-]?[\d]+)/i], ($$9 = function(){var self = $$9.$$s || this, $b;

      
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        return "" + "m[" + (__last__match__1) + "]";}, $$9.$$s = self, $$9.$$arity = 0, $$9));
      string = $send(string, 'gsub', [/r([\+\-]?[\d]+)/i], ($$10 = function(){var self = $$10.$$s || this, $b;

      
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        return "" + "r[" + (__last__match__1) + "]";}, $$10.$$s = self, $$10.$$arity = 0, $$10));
      self.$debug("parren_killer_add after string", string);
      return string;
    }, $SwordWorld_changeText$6.$$arity = 1);
    
    Opal.def(self, '$getRatingCommandStrings', $SwordWorld_getRatingCommandStrings$11 = function $$getRatingCommandStrings() {
      var self = this;

      return "cmCM"
    }, $SwordWorld_getRatingCommandStrings$11.$$arity = 0);
    
    Opal.def(self, '$check_2D6', $SwordWorld_check_2D6$12 = function $$check_2D6(totalValue, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this;

      
      if ($truthy($rb_ge(dice_n, 12))) {
        return " ＞ 自動的成功"};
      if ($truthy($rb_le(dice_n, 2))) {
        return " ＞ 自動的失敗"};
      if ($truthy(signOfInequality['$!='](">="))) {
        return ""};
      if ($truthy(diff['$==']("?"))) {
        return ""};
      if ($truthy($rb_ge(totalValue, diff))) {
        return " ＞ 成功"};
      return " ＞ 失敗";
    }, $SwordWorld_check_2D6$12.$$arity = 8);
    
    Opal.def(self, '$rollDiceCommand', $SwordWorld_rollDiceCommand$13 = function $$rollDiceCommand(command) {
      var self = this;

      return self.$rating(command)
    }, $SwordWorld_rollDiceCommand$13.$$arity = 1);
    
    Opal.def(self, '$rating', $SwordWorld_rating$14 = function $$rating(string) {
      var $a, $b, $$15, self = this, commands = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, rateUp = nil, crit = nil, firstDiceChanteTo = nil, firstDiceChangeModify = nil, key = nil, addValue = nil, rate_sw2_0 = nil, keyMax = nil, newRates = nil, output = nil, values = nil, diceResultTotals = nil, diceResults = nil, rateResults = nil, dice = nil, diceOnlyTotal = nil, totalValue = nil, round = nil, limitLength = nil;
      if ($gvars.SEND_STR_MAX == null) $gvars.SEND_STR_MAX = nil;

      
      self.$debug("rating string", string);
      commands = self.$getRatingCommandStrings();
      if ($truthy(new RegExp("" + "(^|\\s)[sS]?(((k|K)[\\d\\+\\-]+)([" + (commands) + "]\\[([\\d\\+\\-]+)\\])*([\\d\\+\\-]*)([cmrCMR]\\[([\\d\\+\\-]+)\\]|gf|GF)*)($|\\s)")['$=~'](string))) {
      } else {
        
        self.$debug("not matched");
        return "1";
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      string = __last__match__2;
      $b = self.$getRateUpFromString(string), $a = Opal.to_ary($b), (rateUp = ($a[0] == null ? nil : $a[0])), (string = ($a[1] == null ? nil : $a[1])), $b;
      $b = self.$getCriticalFromString(string), $a = Opal.to_ary($b), (crit = ($a[0] == null ? nil : $a[0])), (string = ($a[1] == null ? nil : $a[1])), $b;
      $b = self.$getDiceChangesFromString(string), $a = Opal.to_ary($b), (firstDiceChanteTo = ($a[0] == null ? nil : $a[0])), (firstDiceChangeModify = ($a[1] == null ? nil : $a[1])), (string = ($a[2] == null ? nil : $a[2])), $b;
      $b = self.$getKeyAndAddValueFromString(string), $a = Opal.to_ary($b), (key = ($a[0] == null ? nil : $a[0])), (addValue = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(key['$=~'](/([\d]+)/))) {
      } else {
        return "1"
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      key = __last__match__1.$to_i();
      rate_sw2_0 = self.$getSW2_0_RatingTable();
      keyMax = $rb_minus(rate_sw2_0.$length(), 1);
      self.$debug("keyMax", keyMax);
      if ($truthy($rb_gt(key, keyMax))) {
        return "" + "キーナンバーは" + (keyMax) + "までです"};
      newRates = self.$getNewRates(rate_sw2_0);
      output = "" + "KeyNo." + (key);
      if ($truthy($rb_lt(crit, 13))) {
        output = $rb_plus(output, "" + "c[" + (crit) + "]")};
      if ($truthy(firstDiceChangeModify['$!='](0))) {
        output = $rb_plus(output, "" + "m[" + (firstDiceChangeModify) + "]")};
      if ($truthy(firstDiceChanteTo['$!='](0))) {
        output = $rb_plus(output, "" + "m[" + (firstDiceChanteTo) + "]")};
      if ($truthy(rateUp['$!='](0))) {
        output = $rb_plus(output, "" + "r[" + (rateUp) + "]")};
      $b = self.$getAdditionalString(string, output), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (values = ($a[1] == null ? nil : $a[1])), $b;
      self.$debug("output", output);
      if ($truthy(addValue['$!='](0))) {
        
        if ($truthy($rb_gt(addValue, 0))) {
          output = $rb_plus(output, "" + "+" + (addValue))};
        if ($truthy($rb_lt(addValue, 0))) {
          output = $rb_plus(output, "" + (addValue))};};
      output = $rb_plus(output, " ＞ ");
      diceResultTotals = [];
      diceResults = [];
      rateResults = [];
      dice = 0;
      diceOnlyTotal = 0;
      totalValue = 0;
      round = 0;
      (function(){var $brk = Opal.new_brk(); try {return $send(self, 'loop', [], ($$15 = function(){var self = $$15.$$s || this, $c, $d, diceText = nil, currentKey = nil, rateValue = nil;

      
        $d = self.$rollDice(values), $c = Opal.to_ary($d), (dice = ($c[0] == null ? nil : $c[0])), (diceText = ($c[1] == null ? nil : $c[1])), $d;
        if ($truthy(firstDiceChanteTo['$!='](0))) {
          
          dice = firstDiceChanteTo;
          firstDiceChanteTo = 0;
        } else if ($truthy(firstDiceChangeModify['$!='](0))) {
          
          dice = $rb_plus(dice, firstDiceChangeModify.$to_i());
          firstDiceChangeModify = 0;};
        dice = $rb_plus(dice, self.$getAdditionalDiceValue(dice, values));
        if ($truthy($rb_lt(dice, 2))) {
          dice = 2};
        if ($truthy($rb_gt(dice, 12))) {
          dice = 12};
        currentKey = [$rb_plus(key, $rb_times(round, rateUp)), keyMax].$min();
        self.$debug("currentKey", currentKey);
        rateValue = newRates['$[]'](dice)['$[]'](currentKey);
        self.$debug("rateValue", rateValue);
        totalValue = $rb_plus(totalValue, rateValue);
        diceOnlyTotal = $rb_plus(diceOnlyTotal, dice);
        diceResultTotals['$<<']("" + (dice));
        diceResults['$<<']("" + (diceText));
        rateResults['$<<']((function() {if ($truthy($rb_gt(dice, 2))) {
          return rateValue
        } else {
          return "**"
        }; return nil; })());
        round = $rb_plus(round, 1);
        if ($truthy($rb_ge(dice, crit))) {
          return nil
        } else {
          
          Opal.brk(nil, $brk)
        };}, $$15.$$s = self, $$15.$$brk = $brk, $$15.$$arity = 0, $$15))
      } catch (err) { if (err === $brk) { return err.$v } else { throw err } }})();
      limitLength = $rb_minus($gvars.SEND_STR_MAX, output.$length());
      output = $rb_plus(output, self.$getResultText(totalValue, addValue, diceResults, diceResultTotals, rateResults, diceOnlyTotal, round, crit, limitLength));
      return output;
    }, $SwordWorld_rating$14.$$arity = 1);
    
    Opal.def(self, '$getAdditionalString', $SwordWorld_getAdditionalString$16 = function $$getAdditionalString(string, output) {
      var self = this, values = nil;

      
      values = $hash2([], {});
      return [output, values];
    }, $SwordWorld_getAdditionalString$16.$$arity = 2);
    
    Opal.def(self, '$getAdditionalDiceValue', $SwordWorld_getAdditionalDiceValue$17 = function $$getAdditionalDiceValue(dice, values) {
      var self = this;

      return 0
    }, $SwordWorld_getAdditionalDiceValue$17.$$arity = 2);
    
    Opal.def(self, '$getCriticalFromString', $SwordWorld_getCriticalFromString$18 = function $$getCriticalFromString(string) {
      var $a, self = this, crit = nil, regexp = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      crit = 10;
      regexp = /c\[(\d+)\]/i;
      if ($truthy(regexp['$=~'](string))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        crit = __last__match__1.$to_i();
        if ($truthy($rb_lt(crit, 3))) {
          crit = 3};
        string = string.$gsub(regexp, "");};
      return [crit, string];
    }, $SwordWorld_getCriticalFromString$18.$$arity = 1);
    
    Opal.def(self, '$getDiceChangesFromString', $SwordWorld_getDiceChangesFromString$19 = function $$getDiceChangesFromString(string) {
      var $a, self = this, firstDiceChanteTo = nil, firstDiceChangeModify = nil, regexp = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      firstDiceChanteTo = 0;
      firstDiceChangeModify = 0;
      regexp = /m\[([\d\+\-]+)\]/i;
      if ($truthy(regexp['$=~'](string))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        firstDiceChangeModify = __last__match__1;
        if ($truthy(/[\+\-]/['$=~'](firstDiceChangeModify))) {
        } else {
          
          firstDiceChanteTo = firstDiceChangeModify.$to_i();
          firstDiceChangeModify = 0;
        };
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        string = string.$gsub(regexp, "");};
      return [firstDiceChanteTo, firstDiceChangeModify, string];
    }, $SwordWorld_getDiceChangesFromString$19.$$arity = 1);
    
    Opal.def(self, '$getRateUpFromString', $SwordWorld_getRateUpFromString$20 = function $$getRateUpFromString(string) {
      var self = this, rateUp = nil;

      
      rateUp = 0;
      return [rateUp, string];
    }, $SwordWorld_getRateUpFromString$20.$$arity = 1);
    
    Opal.def(self, '$getKeyAndAddValueFromString', $SwordWorld_getKeyAndAddValueFromString$21 = function $$getKeyAndAddValueFromString(string) {
      var $a, self = this, key = nil, addValue = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      key = nil;
      addValue = 0;
      if ($truthy(/K(\d+)([\d\+\-]*)/i['$=~'](string))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        key = __last__match__1;
        if ($truthy(__last__match__2)) {
          addValue = self.$parren_killer($rb_plus($rb_plus("(", __last__match__2), ")")).$to_i()};
      } else {
        key = string
      };
      return [key, addValue];
    }, $SwordWorld_getKeyAndAddValueFromString$21.$$arity = 1);
    
    Opal.def(self, '$getSW2_0_RatingTable', $SwordWorld_getSW2_0_RatingTable$22 = function $$getSW2_0_RatingTable() {
      var self = this, rate_sw2_0 = nil;

      
      rate_sw2_0 = ["*,0,0,0,1,2,2,3,3,4,4", "*,0,0,0,1,2,3,3,3,4,4", "*,0,0,0,1,2,3,4,4,4,4", "*,0,0,1,1,2,3,4,4,4,5", "*,0,0,1,2,2,3,4,4,5,5", "*,0,1,1,2,2,3,4,5,5,5", "*,0,1,1,2,3,3,4,5,5,5", "*,0,1,1,2,3,4,4,5,5,6", "*,0,1,2,2,3,4,4,5,6,6", "*,0,1,2,3,3,4,4,5,6,7", "*,1,1,2,3,3,4,5,5,6,7", "*,1,2,2,3,3,4,5,6,6,7", "*,1,2,2,3,4,4,5,6,6,7", "*,1,2,3,3,4,4,5,6,7,7", "*,1,2,3,4,4,4,5,6,7,8", "*,1,2,3,4,4,5,5,6,7,8", "*,1,2,3,4,4,5,6,7,7,8", "*,1,2,3,4,5,5,6,7,7,8", "*,1,2,3,4,5,6,6,7,7,8", "*,1,2,3,4,5,6,7,7,8,9", "*,1,2,3,4,5,6,7,8,9,10", "*,1,2,3,4,6,6,7,8,9,10", "*,1,2,3,5,6,6,7,8,9,10", "*,2,2,3,5,6,7,7,8,9,10", "*,2,3,4,5,6,7,7,8,9,10", "*,2,3,4,5,6,7,8,8,9,10", "*,2,3,4,5,6,8,8,9,9,10", "*,2,3,4,6,6,8,8,9,9,10", "*,2,3,4,6,6,8,9,9,10,10", "*,2,3,4,6,7,8,9,9,10,10", "*,2,4,4,6,7,8,9,10,10,10", "*,2,4,5,6,7,8,9,10,10,11", "*,3,4,5,6,7,8,10,10,10,11", "*,3,4,5,6,8,8,10,10,10,11", "*,3,4,5,6,8,9,10,10,11,11", "*,3,4,5,7,8,9,10,10,11,12", "*,3,5,5,7,8,9,10,11,11,12", "*,3,5,6,7,8,9,10,11,12,12", "*,3,5,6,7,8,10,10,11,12,13", "*,4,5,6,7,8,10,11,11,12,13", "*,4,5,6,7,9,10,11,11,12,13", "*,4,6,6,7,9,10,11,12,12,13", "*,4,6,7,7,9,10,11,12,13,13", "*,4,6,7,8,9,10,11,12,13,14", "*,4,6,7,8,10,10,11,12,13,14", "*,4,6,7,9,10,10,11,12,13,14", "*,4,6,7,9,10,10,12,13,13,14", "*,4,6,7,9,10,11,12,13,13,15", "*,4,6,7,9,10,12,12,13,13,15", "*,4,6,7,10,10,12,12,13,14,15", "*,4,6,8,10,10,12,12,13,15,15", "*,5,7,8,10,10,12,12,13,15,15", "*,5,7,8,10,11,12,12,13,15,15", "*,5,7,9,10,11,12,12,14,15,15", "*,5,7,9,10,11,12,13,14,15,16", "*,5,7,10,10,11,12,13,14,16,16", "*,5,8,10,10,11,12,13,15,16,16", "*,5,8,10,11,11,12,13,15,16,17", "*,5,8,10,11,12,12,13,15,16,17", "*,5,9,10,11,12,12,14,15,16,17", "*,5,9,10,11,12,13,14,15,16,18", "*,5,9,10,11,12,13,14,16,17,18", "*,5,9,10,11,13,13,14,16,17,18", "*,5,9,10,11,13,13,15,17,17,18", "*,5,9,10,11,13,14,15,17,17,18", "*,5,9,10,12,13,14,15,17,18,18", "*,5,9,10,12,13,15,15,17,18,19", "*,5,9,10,12,13,15,16,17,19,19", "*,5,9,10,12,14,15,16,17,19,19", "*,5,9,10,12,14,16,16,17,19,19", "*,5,9,10,12,14,16,17,18,19,19", "*,5,9,10,13,14,16,17,18,19,20", "*,5,9,10,13,15,16,17,18,19,20", "*,5,9,10,13,15,16,17,19,20,21", "*,6,9,10,13,15,16,18,19,20,21", "*,6,9,10,13,16,16,18,19,20,21", "*,6,9,10,13,16,17,18,19,20,21", "*,6,9,10,13,16,17,18,20,21,22", "*,6,9,10,13,16,17,19,20,22,23", "*,6,9,10,13,16,18,19,20,22,23", "*,6,9,10,13,16,18,20,21,22,23", "*,6,9,10,13,17,18,20,21,22,23", "*,6,9,10,14,17,18,20,21,22,24", "*,6,9,11,14,17,18,20,21,23,24", "*,6,9,11,14,17,19,20,21,23,24", "*,6,9,11,14,17,19,21,22,23,24", "*,7,10,11,14,17,19,21,22,23,25", "*,7,10,12,14,17,19,21,22,24,25", "*,7,10,12,14,18,19,21,22,24,25", "*,7,10,12,15,18,19,21,22,24,26", "*,7,10,12,15,18,19,21,23,25,26", "*,7,11,13,15,18,19,21,23,25,26", "*,7,11,13,15,18,20,21,23,25,27", "*,8,11,13,15,18,20,22,23,25,27", "*,8,11,13,16,18,20,22,23,25,28", "*,8,11,14,16,18,20,22,23,26,28", "*,8,11,14,16,19,20,22,23,26,28", "*,8,12,14,16,19,20,22,24,26,28", "*,8,12,15,16,19,20,22,24,27,28", "*,8,12,15,17,19,20,22,24,27,29", "*,8,12,15,18,19,20,22,24,27,30"];
      return rate_sw2_0;
    }, $SwordWorld_getSW2_0_RatingTable$22.$$arity = 0);
    
    Opal.def(self, '$getNewRates', $SwordWorld_getNewRates$23 = function $$getNewRates(rate_sw2_0) {
      var $$24, self = this, rate_3 = nil, rate_4 = nil, rate_5 = nil, rate_6 = nil, rate_7 = nil, rate_8 = nil, rate_9 = nil, rate_10 = nil, rate_11 = nil, rate_12 = nil, zeroArray = nil, $writer = nil, newRates = nil;

      
      rate_3 = [];
      rate_4 = [];
      rate_5 = [];
      rate_6 = [];
      rate_7 = [];
      rate_8 = [];
      rate_9 = [];
      rate_10 = [];
      rate_11 = [];
      rate_12 = [];
      zeroArray = [];
      $send(rate_sw2_0, 'each', [], ($$24 = function(rateText){var self = $$24.$$s || this, rate_arr = nil;

      
        
        if (rateText == null) {
          rateText = nil;
        };
        rate_arr = rateText.$split(/,/);
        zeroArray.$push(0);
        rate_3.$push(rate_arr['$[]'](1).$to_i());
        rate_4.$push(rate_arr['$[]'](2).$to_i());
        rate_5.$push(rate_arr['$[]'](3).$to_i());
        rate_6.$push(rate_arr['$[]'](4).$to_i());
        rate_7.$push(rate_arr['$[]'](5).$to_i());
        rate_8.$push(rate_arr['$[]'](6).$to_i());
        rate_9.$push(rate_arr['$[]'](7).$to_i());
        rate_10.$push(rate_arr['$[]'](8).$to_i());
        rate_11.$push(rate_arr['$[]'](9).$to_i());
        return rate_12.$push(rate_arr['$[]'](10).$to_i());}, $$24.$$s = self, $$24.$$arity = 1, $$24));
      if ($truthy(self.rating_table['$=='](1))) {
        
        $writer = [31, (($writer = [32, (($writer = [33, 10]), $send(rate_12, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)])]), $send(rate_12, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)])];
        $send(rate_12, '[]=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];};
      newRates = [zeroArray, zeroArray, zeroArray, rate_3, rate_4, rate_5, rate_6, rate_7, rate_8, rate_9, rate_10, rate_11, rate_12];
      return newRates;
    }, $SwordWorld_getNewRates$23.$$arity = 1);
    
    Opal.def(self, '$rollDice', $SwordWorld_rollDice$25 = function $$rollDice(values) {
      var $a, $b, self = this, dice = nil, diceText = nil;

      
      $b = self.$roll(2, 6), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), (diceText = ($a[1] == null ? nil : $a[1])), $b;
      return [dice, diceText];
    }, $SwordWorld_rollDice$25.$$arity = 1);
    
    Opal.def(self, '$getResultText', $SwordWorld_getResultText$26 = function $$getResultText(totalValue, addValue, diceResults, diceResultTotals, rateResults, diceOnlyTotal, round, crit, limitLength) {
      var self = this, output = nil, totalText = nil, rateResultsText = nil, addText = nil, roundText = nil;

      
      output = "";
      totalText = $rb_plus(totalValue, addValue).$to_s();
      if ($truthy($rb_gt(self.$sendMode(), 1))) {
        
        output = $rb_plus(output, "" + "2D:[" + (diceResults.$join(" ")) + "]=" + (diceResultTotals.$join(",")));
        rateResultsText = rateResults.$join(",");
        if ($truthy(rateResultsText['$=='](totalText))) {
        } else {
          output = $rb_plus(output, "" + " ＞ " + (rateResultsText))
        };
      } else if ($truthy($rb_gt(self.$sendMode(), 0))) {
        output = $rb_plus(output, "" + "2D:" + (diceResultTotals.$join(",")))
      } else {
        output = $rb_plus(output, "" + (totalValue))
      };
      if ($truthy($rb_le(diceOnlyTotal, 2))) {
        return "" + (output) + " ＞ 自動的失敗"};
      addText = self.$getAddText(addValue);
      output = $rb_plus(output, "" + (addText) + " ＞ ");
      roundText = "";
      if ($truthy($rb_gt(round, 1))) {
        roundText = $rb_plus(roundText, "" + ($rb_minus(round, 1)) + "回転 ＞ ")};
      output = $rb_plus(output, "" + (roundText) + (totalText));
      if ($truthy($rb_gt(output.$length(), limitLength))) {
        output = "" + "... ＞ " + (roundText) + (totalText)};
      return output;
    }, $SwordWorld_getResultText$26.$$arity = 9);
    
    Opal.def(self, '$getAddText', $SwordWorld_getAddText$27 = function $$getAddText(addValue) {
      var self = this, addText = nil, operator = nil;

      
      addText = "";
      if ($truthy(addValue['$=='](0))) {
        return addText};
      operator = (function() {if ($truthy($rb_gt(addValue, 0))) {
        return "+"
      } else {
        return ""
      }; return nil; })();
      addText = $rb_plus(addText, "" + (operator) + (addValue));
      return addText;
    }, $SwordWorld_getAddText$27.$$arity = 1);
    return (Opal.def(self, '$setRatingTable', $SwordWorld_setRatingTable$28 = function $$setRatingTable(tnick) {
      var $a, self = this, mode_str = nil, pre_mode = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, $case = nil;

      
      mode_str = "";
      pre_mode = self.rating_table;
      if ($truthy(/(\d+)/['$=~'](tnick))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.rating_table = __last__match__1.$to_i();
        if ($truthy($rb_gt(self.rating_table, 1))) {
          
          mode_str = "2.0-mode";
          self.rating_table = 2;
        } else if ($truthy($rb_gt(self.rating_table, 0))) {
          
          mode_str = "new-mode";
          self.rating_table = 1;
        } else {
          
          mode_str = "old-mode";
          self.rating_table = 0;
        };
      } else {
        $case = tnick;
        if (/old/i['$===']($case)) {
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.rating_table = 0;
        mode_str = "old-mode";}
        else if (/new/i['$===']($case)) {
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.rating_table = 1;
        mode_str = "new-mode";}
        else if (/2\.0/i['$===']($case)) {
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.rating_table = 2;
        mode_str = "2.0-mode";}
      };
      if ($truthy(self.rating_table['$=='](pre_mode))) {
        return "1"};
      return "" + "RatingTableを" + (mode_str) + "に変更しました";
    }, $SwordWorld_setRatingTable$28.$$arity = 1), nil) && 'setRatingTable';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["diceBot/SwordWorld2_0"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $gvars = Opal.gvars, $truthy = Opal.truthy;

  Opal.add_stubs(['$require', '$setPrefixes', '$===', '$=~', '$growth', '$to_i', '$get_fumble_table', '$get_tangle_table', '$__last__match__1', '$gsub', '$getGratestFortuneFromString', '$[]=', '$-', '$+', '$[]', '$roll', '$*', '$<=', '$==', '$>=', '$push', '$debug', '$getOriginalMessage', '$join', '$map', '$growth_step', '$get_ability_by_dice', '$!=', '$get_table_by_1d6']);
  
  self.$require("diceBot/SwordWorld");
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'SwordWorld2_0');

    var $nesting = [self].concat($parent_nesting), $SwordWorld2_0_initialize$1, $SwordWorld2_0_gameName$2, $SwordWorld2_0_gameType$3, $SwordWorld2_0_getHelpMessage$4, $SwordWorld2_0_rollDiceCommand$5, $SwordWorld2_0_getRateUpFromString$6, $SwordWorld2_0_getAdditionalString$7, $SwordWorld2_0_rollDice$8, $SwordWorld2_0_getGratestFortuneFromString$9, $SwordWorld2_0_is2dCritical$10, $SwordWorld2_0_check2dCritical$11, $SwordWorld2_0_check_nD6$12, $SwordWorld2_0_growth$13, $SwordWorld2_0_growth_step$15, $SwordWorld2_0_get_ability_by_dice$16, $SwordWorld2_0_get_fumble_table$17, $SwordWorld2_0_get_tangle_table$18;

    self.$$prototype.bcdice = nil;
    
    self.$setPrefixes(["K\\d+.*", "Gr(\\d+)?", "FT", "TT"]);
    
    Opal.def(self, '$initialize', $SwordWorld2_0_initialize$1 = function $$initialize() {
      var $iter = $SwordWorld2_0_initialize$1.$$p, $yield = $iter || nil, self = this, rating_table = nil;

      if ($iter) $SwordWorld2_0_initialize$1.$$p = null;
      
      rating_table = 2;
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $SwordWorld2_0_initialize$1, false), [], null);
      return (self.rating_table = rating_table);
    }, $SwordWorld2_0_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $SwordWorld2_0_gameName$2 = function $$gameName() {
      var self = this;

      return "ソードワールド2.0"
    }, $SwordWorld2_0_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $SwordWorld2_0_gameType$3 = function $$gameType() {
      var self = this;

      return "SwordWorld2.0"
    }, $SwordWorld2_0_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $SwordWorld2_0_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "自動的成功、成功、失敗、自動的失敗の自動判定を行います。\n" + "\n" + "・レーティング表　(Kx)\n" + "　\"Kキーナンバー+ボーナス\"の形で記入します。\n" + "　ボーナスの部分に「K20+K30」のようにレーティングを取ることは出来ません。\n" + "　また、ボーナスは複数取ることが出来ます。\n" + "　レーティング表もダイスロールと同様に、他のプレイヤーに隠れてロールすることも可能です。\n" + "　例）K20　　　K10+5　　　k30　　　k10+10　　　Sk10-1　　　k10+5+2\n" + "\n" + "・クリティカル値の設定\n" + "　クリティカル値は\"[クリティカル値]\"で指定します。\n" + "　指定しない場合はクリティカル値10とします。\n" + "　クリティカル処理が必要ないときは13などとしてください。(防御時などの対応)\n" + "　またタイプの軽減化のために末尾に「@クリティカル値」でも処理するようにしました。\n" + "　例）K20[10]　　　K10+5[9]　　　k30[10]　　　k10[9]+10　　　k10-5@9\n" + "\n" + "・ダイス目の修正（運命変転やクリティカルレイ用）\n" + "　末尾に「$修正値」でダイス目に修正がかかります。\n" + "　$＋１と修正表記ならダイス目に＋修正、＄９のように固定値ならダイス目をその出目に差し替え。\n" + "　クリティカルした場合でも固定値や修正値の適用は最初の一回だけです。\n" + "　例）K20$+1　　　K10+5$9　　　k10-5@9$+2　　　k10[9]+10$9\n" + "\n" + "・首切り刀用レーティング上昇 r10\n" + "　例）K20r10　K30+24@8R10　K40+24@8$12r10\n" + "\n" + "・グレイテストフォーチュンは末尾に gf\n" + "　例）K20gf　K30+24@8GF　K40+24@8$12r10gf\n" + "\n" + "・超越判定用に2d6ロールに 2D6@10 書式でクリティカル値付与が可能に。\n" + "　例）2D6@10　2D6@10+11>=30\n" + "\n" + "・成長　(Gr)\n" + "　末尾に数字を付加することで、複数回の成長をまとめて行えます。\n" + "　例）Gr3\n" + "\n" + "・防御ファンブル表　(FT)\n" + "　防御ファンブル表を出すことができます。\n" + "\n" + "・絡み効果表　(TT)\n" + "　絡み効果表を出すことができます。\n"
    }, $SwordWorld2_0_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$rollDiceCommand', $SwordWorld2_0_rollDiceCommand$5 = function $$rollDiceCommand(command) {
      var $a, $iter = $SwordWorld2_0_rollDiceCommand$5.$$p, $yield = $iter || nil, self = this, $case = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      if ($iter) $SwordWorld2_0_rollDiceCommand$5.$$p = null;
      return (function() {$case = command;
      if (/^Gr(\d+)?/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      if ($truthy(command['$=~'](/^Gr(\d+)/i))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return self.$growth(__last__match__1.$to_i());
      } else {
        return self.$growth()
      };}
      else if ("FT"['$===']($case)) {return self.$get_fumble_table()}
      else if ("TT"['$===']($case)) {return self.$get_tangle_table()}
      else {return $send(self, Opal.find_super_dispatcher(self, 'rollDiceCommand', $SwordWorld2_0_rollDiceCommand$5, false), [command], null)}})()
    }, $SwordWorld2_0_rollDiceCommand$5.$$arity = 1);
    
    Opal.def(self, '$getRateUpFromString', $SwordWorld2_0_getRateUpFromString$6 = function $$getRateUpFromString(string) {
      var self = this, rateUp = nil, regexp = nil;

      
      rateUp = 0;
      regexp = /r\[(\d+)\]/i;
      if ($truthy(regexp['$==='](string))) {
        
        rateUp = self.$__last__match__1().$to_i();
        string = string.$gsub(regexp, "");};
      return [rateUp, string];
    }, $SwordWorld2_0_getRateUpFromString$6.$$arity = 1);
    
    Opal.def(self, '$getAdditionalString', $SwordWorld2_0_getAdditionalString$7 = function $$getAdditionalString(string, output) {
      var $a, $b, $iter = $SwordWorld2_0_getAdditionalString$7.$$p, $yield = $iter || nil, self = this, values = nil, isGratestFortune = nil, $writer = nil;

      if ($iter) $SwordWorld2_0_getAdditionalString$7.$$p = null;
      
      $b = $send(self, Opal.find_super_dispatcher(self, 'getAdditionalString', $SwordWorld2_0_getAdditionalString$7, false), [string, output], null), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (values = ($a[1] == null ? nil : $a[1])), $b;
      $b = self.$getGratestFortuneFromString(string), $a = Opal.to_ary($b), (isGratestFortune = ($a[0] == null ? nil : $a[0])), (string = ($a[1] == null ? nil : $a[1])), $b;
      
      $writer = ["isGratestFortune", isGratestFortune];
      $send(values, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      if ($truthy(isGratestFortune)) {
        output = $rb_plus(output, "gf")};
      return [output, values];
    }, $SwordWorld2_0_getAdditionalString$7.$$arity = 2);
    
    Opal.def(self, '$rollDice', $SwordWorld2_0_rollDice$8 = function $$rollDice(values) {
      var $a, $b, $iter = $SwordWorld2_0_rollDice$8.$$p, $yield = $iter || nil, self = this, dice = nil, diceText = nil;

      if ($iter) $SwordWorld2_0_rollDice$8.$$p = null;
      
      if ($truthy(values['$[]']("isGratestFortune"))) {
      } else {
        return $send(self, Opal.find_super_dispatcher(self, 'rollDice', $SwordWorld2_0_rollDice$8, false), [values], null)
      };
      $b = self.$roll(1, 6), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), (diceText = ($a[1] == null ? nil : $a[1])), $b;
      dice = $rb_times(dice, 2);
      diceText = "" + (diceText) + "," + (diceText);
      return [dice, diceText];
    }, $SwordWorld2_0_rollDice$8.$$arity = 1);
    
    Opal.def(self, '$getGratestFortuneFromString', $SwordWorld2_0_getGratestFortuneFromString$9 = function $$getGratestFortuneFromString(string) {
      var self = this, isGratestFortune = nil, regexp = nil;

      
      isGratestFortune = false;
      regexp = /gf/i;
      if ($truthy(regexp['$==='](string))) {
        
        isGratestFortune = true;
        string = string.$gsub(regexp, "");};
      return [isGratestFortune, string];
    }, $SwordWorld2_0_getGratestFortuneFromString$9.$$arity = 1);
    
    Opal.def(self, '$is2dCritical', $SwordWorld2_0_is2dCritical$10 = function $$is2dCritical() {
      var self = this;

      return true
    }, $SwordWorld2_0_is2dCritical$10.$$arity = 0);
    
    Opal.def(self, '$check2dCritical', $SwordWorld2_0_check2dCritical$11 = function $$check2dCritical(critical, dice_new, dice_arry, loop_count) {
      var self = this;

      
      if ($truthy($rb_le(critical, 2))) {
        return nil};
      if ($truthy(loop_count['$=='](0))) {
        
        if ($truthy(dice_new['$=='](12))) {
          return nil};
        if ($truthy(dice_new['$=='](2))) {
          return nil};};
      if ($truthy($rb_ge(dice_new, critical))) {
        return dice_arry.$push(2)
      } else {
        return nil
      };
    }, $SwordWorld2_0_check2dCritical$11.$$arity = 4);
    
    Opal.def(self, '$check_nD6', $SwordWorld2_0_check_nD6$12 = function $$check_nD6(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var $a, $iter = $SwordWorld2_0_check_nD6$12.$$p, $yield = $iter || nil, self = this, result = nil, string = nil, superSuccessValue = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, critical = nil;

      if ($iter) $SwordWorld2_0_check_nD6$12.$$p = null;
      
      self.$debug("check_nD6");
      result = $send(self, Opal.find_super_dispatcher(self, 'check_nD6', $SwordWorld2_0_check_nD6$12, false), [total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max], null);
      if ($truthy(result['$=='](""))) {
      } else {
        return result
      };
      string = self.bcdice.$getOriginalMessage();
      superSuccessValue = 41;
      if ($truthy(/@(\d+)/['$==='](string))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        critical = __last__match__1.$to_i();
        if ($truthy($rb_ge(dice_n, critical))) {
          if ($truthy($rb_ge(total_n, superSuccessValue))) {
            return " ＞ 超成功"}};};
      return result;
    }, $SwordWorld2_0_check_nD6$12.$$arity = 8);
    
    Opal.def(self, '$growth', $SwordWorld2_0_growth$13 = function $$growth(count) {
      var $$14, self = this;

      
      
      if (count == null) {
        count = 1;
      };
      return $send(Opal.Range.$new(1, count, false), 'map', [], ($$14 = function(){var self = $$14.$$s || this;

      return self.$growth_step()}, $$14.$$s = self, $$14.$$arity = 0, $$14)).$join(" | ");
    }, $SwordWorld2_0_growth$13.$$arity = -1);
    
    Opal.def(self, '$growth_step', $SwordWorld2_0_growth_step$15 = function $$growth_step() {
      var $a, $b, self = this, d1 = nil, d2 = nil, a1 = nil, a2 = nil;

      
      $b = self.$roll(1, 6), $a = Opal.to_ary($b), (d1 = ($a[0] == null ? nil : $a[0])), $b;
      $b = self.$roll(1, 6), $a = Opal.to_ary($b), (d2 = ($a[0] == null ? nil : $a[0])), $b;
      a1 = self.$get_ability_by_dice(d1);
      a2 = self.$get_ability_by_dice(d2);
      return (function() {if ($truthy(a1['$!='](a2))) {
        return "" + "[" + (d1) + "," + (d2) + "]->(" + (a1) + " or " + (a2) + ")"
      } else {
        return "" + "[" + (d1) + "," + (d2) + "]->(" + (a1) + ")"
      }; return nil; })();
    }, $SwordWorld2_0_growth_step$15.$$arity = 0);
    
    Opal.def(self, '$get_ability_by_dice', $SwordWorld2_0_get_ability_by_dice$16 = function $$get_ability_by_dice(dice) {
      var self = this;

      return ["器用度", "敏捷度", "筋力", "生命力", "知力", "精神力"]['$[]']($rb_minus(dice, 1))
    }, $SwordWorld2_0_get_ability_by_dice$16.$$arity = 1);
    
    Opal.def(self, '$get_fumble_table', $SwordWorld2_0_get_fumble_table$17 = function $$get_fumble_table() {
      var $a, $b, self = this, table = nil, text = nil, num = nil;

      
      table = ["この表を2回振り、その両方を適用する。（同じ出目による影響は累積しない）。この自動失敗により得られる経験点は、+50点される", "ダメージに、攻撃者を強化している「剣のかけら」の数が追加される", "ダメージに、攻撃者の「レベル」が追加される", "ダメージ決定を2回行い、より高い方を採用する", "合算ダメージを2倍する", "防護点無効"];
      $b = self.$get_table_by_1d6(table), $a = Opal.to_ary($b), (text = ($a[0] == null ? nil : $a[0])), (num = ($a[1] == null ? nil : $a[1])), $b;
      return "" + "防御ファンブル表(" + (num) + ") → " + (text);
    }, $SwordWorld2_0_get_fumble_table$17.$$arity = 0);
    return (Opal.def(self, '$get_tangle_table', $SwordWorld2_0_get_tangle_table$18 = function $$get_tangle_table() {
      var $a, $b, self = this, table = nil, text = nil, num = nil;

      
      table = ["頭や顔：牙や噛みつきなどにおける命中力判定及び、魔法の行使やブレスに-2のペナルティ修正を受ける", "武器や盾：武器の使用不可、又は盾の回避力修正及び防護点を無効化する", "腕や手：武器や爪などにおける命中力判定に-2のペナルティ修正、盾を持つ腕方の腕ならその盾の回避力修正及び防護点を無効化する", "脚や足：移動不可、更に回避力判定に-2のペナルティ修正を受ける ※両足に絡んでも累積しない", "胴体：生命・精神抵抗力を基準値に用いる判定を除き、あらゆる行為判定に-1のペナルティ修正を受ける", "特殊：尻尾や翼などに命中。絡められた部位を使用する判定において-2のペナルティ修正、またはそこが使えていたことによるボーナス修正を失う ※存在しない場合は決め直し"];
      $b = self.$get_table_by_1d6(table), $a = Opal.to_ary($b), (text = ($a[0] == null ? nil : $a[0])), (num = ($a[1] == null ? nil : $a[1])), $b;
      return "" + "絡み効果表(" + (num) + ") → " + (text);
    }, $SwordWorld2_0_get_tangle_table$18.$$arity = 0), nil) && 'get_tangle_table';
  })($nesting[0], $$($nesting, 'SwordWorld'), $nesting);
};

/* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars;

  Opal.add_stubs(['$require', '$setPrefixes', '$=~', '$debug', '$gsub', '$to_i', '$>=', '$+', '$getKeptDiceChangesFromString', '$[]=', '$-', '$!=', '$[]']);
  
  self.$require("diceBot/SwordWorld2_0");
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'SwordWorld2_5');

    var $nesting = [self].concat($parent_nesting), $SwordWorld2_5_initialize$1, $SwordWorld2_5_gameName$2, $SwordWorld2_5_gameType$3, $SwordWorld2_5_getHelpMessage$4, $SwordWorld2_5_changeText$5, $SwordWorld2_5_getRatingCommandStrings$7, $SwordWorld2_5_getAdditionalString$8, $SwordWorld2_5_getAdditionalDiceValue$9, $SwordWorld2_5_getKeptDiceChangesFromString$10;

    
    self.$setPrefixes(["K\\d+.*", "Gr(\\d+)?", "FT", "TT"]);
    
    Opal.def(self, '$initialize', $SwordWorld2_5_initialize$1 = function $$initialize() {
      var $iter = $SwordWorld2_5_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $SwordWorld2_5_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      return $send(self, Opal.find_super_dispatcher(self, 'initialize', $SwordWorld2_5_initialize$1, false), $zuper, $iter)
    }, $SwordWorld2_5_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $SwordWorld2_5_gameName$2 = function $$gameName() {
      var self = this;

      return "ソードワールド2.5"
    }, $SwordWorld2_5_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $SwordWorld2_5_gameType$3 = function $$gameType() {
      var self = this;

      return "SwordWorld2.5"
    }, $SwordWorld2_5_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $SwordWorld2_5_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "自動的成功、成功、失敗、自動的失敗の自動判定を行います。\n" + "\n" + "・レーティング表　(Kx)\n" + "　\"Kキーナンバー+ボーナス\"の形で記入します。\n" + "　ボーナスの部分に「K20+K30」のようにレーティングを取ることは出来ません。\n" + "　また、ボーナスは複数取ることが出来ます。\n" + "　レーティング表もダイスロールと同様に、他のプレイヤーに隠れてロールすることも可能です。\n" + "　例）K20　　　K10+5　　　k30　　　k10+10　　　Sk10-1　　　k10+5+2\n" + "\n" + "・クリティカル値の設定\n" + "　クリティカル値は\"[クリティカル値]\"で指定します。\n" + "　指定しない場合はクリティカル値10とします。\n" + "　クリティカル処理が必要ないときは13などとしてください。(防御時などの対応)\n" + "　またタイプの軽減化のために末尾に「@クリティカル値」でも処理するようにしました。\n" + "　例）K20[10]　　　K10+5[9]　　　k30[10]　　　k10[9]+10　　　k10-5@9\n" + "\n" + "・ダイス目の修正（運命変転やクリティカルレイ用）\n" + "　末尾に「$修正値」でダイス目に修正がかかります。\n" + "　$＋１と修正表記ならダイス目に＋修正、＄９のように固定値ならダイス目をその出目に差し替え。\n" + "　クリティカルした場合でも固定値や修正値の適用は最初の一回だけです。\n" + "　例）K20$+1　　　K10+5$9　　　k10-5@9$+2　　　k10[9]+10$9\n" + "\n" + "・ダイス目の修正（必殺攻撃用）\n" + "　「＃修正値」でダイス目に修正がかかります。\n" + "　クリティカルした場合でも修正値の適用は継続されます。\n" + "　例）K20#1　　　k10-5@9#2\n" + "\n" + "・首切り刀用レーティング上昇 r10\n" + "　例）K20r10　K30+24@8R10　K40+24@8$12r10\n" + "\n" + "・グレイテストフォーチュンは末尾に gf\n" + "　例）K20gf　K30+24@8GF　K40+24@8$12r10gf\n" + "\n" + "・超越判定用に2d6ロールに 2D6@10 書式でクリティカル値付与が可能に。\n" + "　例）2D6@10　2D6@10+11>=30\n" + "\n" + "・成長　(Gr)\n" + "　末尾に数字を付加することで、複数回の成長をまとめて行えます。\n" + "　例）Gr3\n" + "\n" + "・防御ファンブル表　(FT)\n" + "　防御ファンブル表を出すことができます。\n" + "\n" + "・絡み効果表　(TT)\n" + "　絡み効果表を出すことができます。\n"
    }, $SwordWorld2_5_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$changeText', $SwordWorld2_5_changeText$5 = function $$changeText(string) {
      var $a, $$6, $iter = $SwordWorld2_5_changeText$5.$$p, $yield = $iter || nil, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      if ($iter) $SwordWorld2_5_changeText$5.$$p = null;
      
      if ($truthy(/(^|\s)[sS]?(K[\d]+)/i['$=~'](string))) {
      } else {
        return string
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      string = $send(self, Opal.find_super_dispatcher(self, 'changeText', $SwordWorld2_5_changeText$5, false), [string], null);
      self.$debug("parren_killer_add before string", string);
      string = $send(string, 'gsub', [/#([\+\-]?[\d]+)/i], ($$6 = function(){var self = $$6.$$s || this, value = nil;

      
        value = __last__match__1.$to_i();
        if ($truthy($rb_ge(value, 0))) {
          return "" + "a[+" + (value) + "]"
        } else {
          return "" + "a[" + (value) + "]"
        };}, $$6.$$s = self, $$6.$$arity = 0, $$6));
      self.$debug("parren_killer_add after string", string);
      return string;
    }, $SwordWorld2_5_changeText$5.$$arity = 1);
    
    Opal.def(self, '$getRatingCommandStrings', $SwordWorld2_5_getRatingCommandStrings$7 = function $$getRatingCommandStrings() {
      var $iter = $SwordWorld2_5_getRatingCommandStrings$7.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $SwordWorld2_5_getRatingCommandStrings$7.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      return $rb_plus($send(self, Opal.find_super_dispatcher(self, 'getRatingCommandStrings', $SwordWorld2_5_getRatingCommandStrings$7, false), $zuper, $iter), "aA")
    }, $SwordWorld2_5_getRatingCommandStrings$7.$$arity = 0);
    
    Opal.def(self, '$getAdditionalString', $SwordWorld2_5_getAdditionalString$8 = function $$getAdditionalString(string, output) {
      var $a, $b, $iter = $SwordWorld2_5_getAdditionalString$8.$$p, $yield = $iter || nil, self = this, values = nil, keptDiceChangeModify = nil, $writer = nil;

      if ($iter) $SwordWorld2_5_getAdditionalString$8.$$p = null;
      
      $b = $send(self, Opal.find_super_dispatcher(self, 'getAdditionalString', $SwordWorld2_5_getAdditionalString$8, false), [string, output], null), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (values = ($a[1] == null ? nil : $a[1])), $b;
      $b = self.$getKeptDiceChangesFromString(string), $a = Opal.to_ary($b), (keptDiceChangeModify = ($a[0] == null ? nil : $a[0])), (string = ($a[1] == null ? nil : $a[1])), $b;
      
      $writer = ["keptDiceChangeModify", keptDiceChangeModify];
      $send(values, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      if ($truthy(keptDiceChangeModify['$!='](0))) {
        output = $rb_plus(output, "" + "a[" + (keptDiceChangeModify) + "]")};
      return [output, values];
    }, $SwordWorld2_5_getAdditionalString$8.$$arity = 2);
    
    Opal.def(self, '$getAdditionalDiceValue', $SwordWorld2_5_getAdditionalDiceValue$9 = function $$getAdditionalDiceValue(dice, values) {
      var $a, self = this, keptDiceChangeModify = nil, value = nil;

      
      keptDiceChangeModify = values['$[]']("keptDiceChangeModify").$to_i();
      value = 0;
      if ($truthy(($truthy($a = keptDiceChangeModify['$!='](0)) ? dice['$!='](2) : $a))) {
        value = $rb_plus(value, keptDiceChangeModify.$to_i())};
      return value;
    }, $SwordWorld2_5_getAdditionalDiceValue$9.$$arity = 2);
    return (Opal.def(self, '$getKeptDiceChangesFromString', $SwordWorld2_5_getKeptDiceChangesFromString$10 = function $$getKeptDiceChangesFromString(string) {
      var $a, self = this, keptDiceChangeModify = nil, regexp = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      keptDiceChangeModify = 0;
      regexp = /a\[([\+\-]\d+)\]/i;
      if ($truthy(regexp['$=~'](string))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        keptDiceChangeModify = __last__match__1;
        string = string.$gsub(regexp, "");};
      return [keptDiceChangeModify, string];
    }, $SwordWorld2_5_getKeptDiceChangesFromString$10.$$arity = 1), nil) && 'getKeptDiceChangesFromString';
  })($nesting[0], $$($nesting, 'SwordWorld2_0'), $nesting);
})(Opal);
